import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

type Tone = 'neutral' | 'success' | 'brand';

const TONES: Record<Tone, string> = {
  neutral: 'bg-surface text-soft border-line',
  success: 'bg-success-soft text-success-text border-transparent',
  brand: 'bg-brand-50 text-brand-700 border-transparent',
};

export function Chip({ tone = 'neutral', icon, children, className, ...rest }: {
  tone?: Tone;
  icon?: ReactNode;
  children: ReactNode;
  className?: string;
  'data-testid'?: string;
}) {
  return (
    <span
      className={cn('inline-flex h-7 items-center gap-1.5 whitespace-nowrap rounded-pill border px-3 text-[13px] font-medium', TONES[tone], className)}
      {...rest}
    >
      {tone === 'success' && !icon && <span className="h-[7px] w-[7px] rounded-pill bg-success" aria-hidden="true" />}
      {icon}
      {children}
    </span>
  );
}
